import React from "react"
import { SortTypes, Sorting, Column } from "./types"

export const selectSorting = (
  sortBy: string,
  currentSortBy: string,
  currentOrder: SortTypes
): Sorting => {
  if (sortBy === currentSortBy) {
    return {
      sortBy: currentSortBy,
      order: currentOrder === SortTypes.asc ? SortTypes.desc : SortTypes.asc
    }
  }

  return { sortBy, order: SortTypes.asc }
}

export const defaultSorter =
  (sortBy: string, order: SortTypes) =>
  (item1: any, item2: any): number => {
    if (!sortBy || !order) return 0

    const [source, target] =
      order === SortTypes.asc ? [item1, item2] : [item2, item1]
    const sourceProp = source?.[sortBy]
    const targetProp = target?.[sortBy]

    // If one of items is number, compare like numbers.
    if (typeof sourceProp === "number" || typeof targetProp === "number") {
      const sourceNumber = sourceProp ?? -Infinity
      const targetNumber = targetProp ?? -Infinity
      return sourceNumber - targetNumber
    }

    // Cast others to strings.
    const sourceStr = sourceProp?.toString() ?? ""
    const targetStr = targetProp?.toString() ?? ""
    return sourceStr.localeCompare(targetStr)
  }

export const getSortIconName = (
  sortBy: string,
  order: SortTypes,
  sortId: string
): string => {
  if (sortBy === sortId && order === SortTypes.asc) return "sort-up"

  if (sortBy === sortId && order === SortTypes.desc) return "sort-down"

  return "sort"
}

// Helper to flatten grouped columns for table display
export const flattenTableColumns = (columns: Column[]): Column[] => {
  return columns.flatMap(col =>
    col.columns?.length ? flattenTableColumns(col.columns) : [col]
  )
}

export const transformDiagonalHeaderStyle = (
  diagonalHeader: boolean,
  isMobile: boolean,
  style: React.CSSProperties
) => {
  if (!diagonalHeader) return null

  const columnWidth = style?.width
  if (!columnWidth) return null

  const width =
    typeof columnWidth === "number"
      ? columnWidth
      : parseInt(String(columnWidth).replace("px", ""), 10)

  if (isNaN(width)) return null

  let translateX: number
  let translateY: number

  if (isMobile) {
    translateX = Math.round((47 / 60) * width - 17)
    translateY = Math.round(68 - 0.4 * width)
  } else {
    translateX = Math.round(0.8 * width - 16)
    translateY = Math.round(76 - 0.433 * width)
  }

  const rotate = 305

  return {
    transform: `translate(${translateX}px, ${translateY}px) rotate(${rotate}deg)`
  }
}
